import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col,Pagination} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:"20%"
    },
    {
        title: 'استان',
        dataIndex: 'stateId',
        width:"7%"
    },
    {
        title: 'شهر',
        dataIndex: 'cityId',
        width:"8%"
    },
    {
        title: 'مبلغ(ریال)',
        dataIndex: 'price',
        sorter: (a, b) => a.price.length - b.price.length,
        width:"10%",
        className:"price"
    },
    {
        title: 'کمیسیون(ریال)',
        dataIndex: 'commuting',
        sorter: (a, b) => a.commuting.length - b.commuting.length,
        className:"price",
        width:'10%'
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:'5%'
    },
  ];


class ServiceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            filter:[]
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    title : list.lists[i].title,
                    cityId: list.lists[i].city.title,
                    stateId: list.lists[i].state.title,
                    price : (list.lists[i].price).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    commuting: (list.lists[i].commuting).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    action: <Tooltip placement="top" title="ویرایش">
                                <a href={"#/service/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                            </Tooltip>
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={20}>
                        <Divider orientation="left">لیست خدمات</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={4} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/service/add">
                            ایجاد خدمت
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default ServiceList = reduxForm({
    form: 'list'
})(ServiceList)
